import { Injectable, Injector } from '@angular/core';
import { ClickStream } from '../models/click-stream.model';
import { UserService } from './user.service';
import { User } from '../models/user.model';
import { environment } from 'src/environments/environment';
import { first } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ClickStreamService {

  private sessionId: string;
  private user: User;

  private browser = "Undefined";

  private _window: any = window;
  private _doc: any = document;

  constructor(private readonly inj: Injector, private http: HttpClient, private cookieService: CookieService) { } //use injector to avoid circular dependancies(spelling?)

  send(event: string, eventType: string, pageTitle: string = '', area: string = '', value: string = '', userAction: boolean = true) {
    if (!this.user) {
      this.init();
    }
    let clickstream = this.buildEvent();
    clickstream.eventName = event;
    clickstream.eventType = eventType;
    clickstream.pageTitle = pageTitle;
    clickstream.area = area;
    clickstream.value = value;
    clickstream.isUserAction = userAction;

    this.http.post(`${environment.apis.thirdParty}/clickstream/capture`, clickstream).pipe(first()).subscribe((result) => {/* /shruggie */ });
  }

  private init() {
    const userService = this.inj.get(UserService);
    this.user = userService.getUser();
    this.sessionId = this.cookieService.get('user_session') + '-' + Date.now();
    this.sessionId = this.user.gmid + '-' + Date.now();
    this.getBrowserType();
  }

  private buildEvent() {
    let clickstream = new ClickStream();
    if (window.location.href.indexOf('vsp') !== -1 || window.location.href.indexOf('autopartners') !== -1) {
      clickstream.gmid = this.cookieService.get('user_session');
    } else {
      clickstream.gmid = this.user.gmid;
    }
    clickstream.sessionId = this.sessionId;
    clickstream.browser = this.browser;
    clickstream.browserHeight = window.innerHeight;
    clickstream.browserWidth = window.innerWidth;
    clickstream.screenHeight = window.screen.height;
    clickstream.screenWidth = window.screen.width;
    clickstream.url = window.location.href;

    return clickstream;
  }

  private getBrowserType() {
    var isChromium = this._window.chrome;
    var winNav = this._window.navigator;
    var vendorName = winNav.vendor;
    var isOpera = typeof this._window.opr !== "undefined";
    var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
    var isIOSChrome = winNav.userAgent.match("CriOS");

    if (isIOSChrome) {
      // is Google Chrome on IOS
    } else if (
      isChromium !== null &&
      typeof isChromium !== "undefined" &&
      vendorName === "Google Inc." &&
      isOpera === false &&
      isIEedge === false
    ) {
      this.browser = "Chrome";
      return this.browser;
    }

    var isOpera = (!!this._window.opr && !!this._window.opr.addons) || !!this._window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isSafari = /constructor/i.test(this._window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!this._window['safari'] || this._doc.safari.pushNotification);
    var isIE = /*@cc_on!@*/false || !!this._doc.documentMode;
    var isEdge = !isIE && !!this._window.StyleMedia;
    if (isIE) {
      this.browser = "Internet Explorer";
      var version = this.getIEVersion()
      if (version) {
        this.browser += version;
      }
    }
    else if (isEdge) {
      this.browser = "Edge";
    }
    else if (isOpera) {
      this.browser = "Opera";
    }
    else if (isSafari) {
      this.browser = "Safari";
    }
    else {
      this.browser = "Firefox";
    }
    return this.browser;
  }

  getIEVersion() {
    var myNav = navigator.userAgent.toLowerCase();
    return (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : false;
  }
}
